<template lang="pug">
  v-flex(xs12 md10 offset-md1)
    v-stepper(v-model='e1' :vertical="isMobile" v-resize='onResize')
      v-stepper-header(v-if='!isMobile')
        v-stepper-step(:complete='e1 > 1', step='1') Inicio
        v-divider
        v-stepper-step(:complete='e1 > 2', step='2') Contenido
        v-divider
        v-stepper-step(:complete='e1 > 3', step='3') Adjuntar Imagen
        v-divider
        v-stepper-step(:complete='e1 > 4', step='4') Vista Previa
      v-stepper-items
        v-stepper-step( v-if='isMobile' :complete='e1 > 1', step='1') Crea un título
        v-stepper-content(step='1' height="200px" )
          v-card.mb-5
            v-text-field(v-model='model.title', label='Titulo'  type="text")
            v-text-field(v-model='model.subject', label='Asunto'  type="text")
          v-btn( link @click="clear") Cancel
          v-btn(color='primary', @click='e1 = 2', :disabled='validate(1)')
            | Siguiente
        v-stepper-step(v-if='isMobile' :complete='e1 > 2', step='2') Escribe el contenido
        v-stepper-content(step='2')
          v-card.mb-5
            div(class="inputGroupClass")
              label Contenido
              div.pt-2
                quill-editor(v-model='model.content')
          v-btn(, @click='e1 = 1') Atrás
          v-btn(color='primary' @click='e1 = 3' , :disabled ='validate(2)')
            | Siguiente
        v-stepper-step(v-if='isMobile ' :complete='e1 > 3', step='3') Adjuntar Imagen
        v-stepper-content(step='3' )
          v-card.mb-5
            div(class="inputGroupClass")
              label Subir imagen
              v-btn(small color='primary' @click="pickFile('imageInput')") Subir
              v-flex(pt-2)
                input(type='file', style='display: none', ref='imageInput', @change="onImagePicked" accept="image/*")
                v-progress-circular(v-show='imageLoading' :size='70', :width='7', color='purple', indeterminate='')
                img(style='max-width: 300px; max-height: 200px' name='image' v-show='!!model.image', :src='model.image')
          v-btn(, @click='e1 = 2') Atrás
          v-btn(color='primary',@click='e1 = 4' , :disabled ='!model.image')
            | Siguiente
        v-stepper-step(v-if='isMobile' step='4') Vista Previa
        v-stepper-content(step='4')
          v-layout(xs12)
            v-card( style="max-width: 600px;").mx-auto.mb-3
              v-flex(d-flex justify-center)
                img.white--text(style='overflow:unset; max-height: 350px; object-fit: cover;'  :src='model.image')
              v-card-title
                v-flex(column)
                  h1.headline {{model.title}}
                  div
                    span.grey--text {{model.subject}}
              v-slide-y-transition
                v-card-text(v-html="model.content")
          v-btn(:disabled='loading' , @click=' e1 = 3 ') Back
          v-btn(color='primary', @click='save', :disabled='loading' :loading="loading")
            | Publicar
</template>
<script>
  // import axios from 'axios'
  import Swal from 'sweetalert2'
  export default {
    props: {
      model: Object,
      context: String,
      onSave: {
        type: Function,
        required: true,
      },
    },
    data () {
      return {
        e1: 1,
        show: false,
        isMobile: false,
        imageLoading: false,
        audioLoading: false,
      }
    },
    computed: {
      loading () {
        // return this.$store.getters.getLoading
        return false
      },
    },
    mounted () {
      const vm = this
      vm.onResize()
    },
    methods: {
      clear () {
        this.$emit('onClose')
      },
      save () {
        this.onSave()
        this.$forceUpdate()
        this.e1 = 1
        this.$emit('onClose')
      },
      pickFile (ref) {
        this.$refs[ref].click()
      },
      onAudioPicked (event) {
        const vm = this
        const files = event.target.files

        const filename = files[0].name

        if (filename.lastIndexOf('.') <= 0) {
          return alert('Agrega un archivo valido')
        }
        const fileReader = new FileReader()
        fileReader.addEventListener('loadstart', () => {
          vm.audioLoading = true
        })
        fileReader.addEventListener('loadend', function () {
          vm.audioLoading = false
          // console.log('acabo de subir el archivo de audio')
          vm.setAudio(fileReader.result)
          // console.log(fileReader.result)
        })
        fileReader.readAsDataURL(files[0])
      },
      onImagePicked (event) {
        const vm = this
        const files = event.target.files
        // console.log(files[0])
        if (files[0].type.includes('image')) {
          const filename = files[0].name
          if (filename.lastIndexOf('.') <= 0) {
            return alert('Agrega un archivo valido')
          }
          const fileReader = new FileReader()
          fileReader.addEventListener('load', () => {
            vm.imageLoading = true
            vm.setImage(fileReader.result)
          })
          fileReader.addEventListener('loadend', function () {
            vm.imageLoading = false
            // console.log('acabo de subir el archivo de imagen')
          })
          fileReader.readAsDataURL(files[0])
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'El archivo subido no es valido',
          })
        }
      },
      setAudio (audio) {
        this.model.audio = audio
        this.$forceUpdate()
      },
      setImage (image) {
        this.model.image = image
        this.$forceUpdate()
      },
      onResize () {
        this.isMobile = window.innerWidth < 1024
      },
      validate (step) {
        switch (step) {
          case 1:
            if (this.model.title && this.model.subject) {
              if (this.model.title !== this.model.title.trim() ||
                this.model.subject !== this.model.subject.trim()) {
                return true
              } else {
                return false
              }
            } else {
              return true
            }
          case 2:
            if (this.model.content) {
              if (this.model.content !== this.model.content.trim()) {
                return true
              } else {
                return false
              }
            } else {
              return true
            }
          default:
            return false
        }
      },
    },

  }
</script>
